module.exports = __webpack_public_path__ + "img/info-fill-idp.7997cccf.svg";